export default {
    'default':{
        title: 'Упс!😓',
        text: 'Мы пока не придумали что тут написать',
    },
    'wizard-step-1': {
        title: 'Счета:',
        text: `На счетах учитываются балансы денежных средств. <br>
               <br>
               Вы можете создать сколько угодно счетов в разных валютах. Вы можете контролировать баланс даже на крипто-кошельках, а MoneyKeeper будет следить за актуальными курсами при совершении операций и расчете общего капитала.<br>
               <br>
               Если у вас много счетов - можете использовать группы - для этого, включите “группы” по ссылке “настройки счетов”.<br>
               <br>
               Индивидуальная настройка каждого счета позволяет учитывать баланс в общем капитале и группе счетов, рассчитывать комиссии при внесении операций, а также менять иконку и другие опции.<br>
               <br>
               Скоро мы проведем интеграции с банками, чтобы операции вносились в MoneyKeeper в автоматическом или полуавтоматическом режиме. Следите за новостями.<br>`
    },
    'wizard-step-2': {
        title: 'Источники дохода:',
        text: `Использование разных источников дохода позволят вам контролировать денежные поступления и планировать доходный бюджет по каждому источнику.<br>
               <br>
               “Вовлеченность” отражает степень приложения ваших усилий к получению дохода и позволяет вам отследить, как меняется структура ваших доходов со временем.<br>
               <br>
               Степени вовлеченности:<br>
               <br>
               Активный - доход требует затрат вашего времени и сил: работа по найму, фриланс.<br>
               Полупассивный - потребует вашего внимания и некоторого времени: посуточная аренда жилья или доход с проекта.<br>
               Пассивный - получение дохода не требует вашего участия: инвестиции, пенсия.<br><br>
               Внимательно посмотрите все категории доходов, это поможет вам не упустить ни одного источника - добавьте их все!<br>`
    },
    'wizard-step-3': {
        title: 'Категории расходов:',
        text: `Категории расходов позволят вам:<br>
               <br>
               – детально планировать бюджет на месяц<br>
               – анализировать траты с целью дальнейшей оптимизации<br>
               – наглядно видеть в статистике - куда уходят деньги.<br><br>
               Добавьте категории, которые отражают структуру ваших расходов. <br>
               Используйте группы для объединения категорий расходов по тематике. Например, для категорий “продукты”, “обеды” и “фастфуд” можно создать группу “питание”.<br>`
    }
}